import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { Settings } from 'luxon'
import React, { createContext } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import './index.css'
import reportWebVitals from './reportWebVitals'
import router from './routes/Router'
import RootStore from './stores'

Settings.defaultZone = 'Asia/Tokyo'
Settings.defaultLocale = 'ja'

const rootStore = new RootStore()
export const RootStoresContext = createContext<RootStore>(rootStore)

const root = createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <RootStoresContext.Provider value={rootStore}>
    <React.StrictMode>
      <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="ja">
        <RouterProvider router={router} />
      </LocalizationProvider>
    </React.StrictMode>
  </RootStoresContext.Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
